import { render, staticRenderFns } from "./Annouce.vue?vue&type=template&id=6ec5ccc0"
import script from "./Annouce.vue?vue&type=script&lang=js"
export * from "./Annouce.vue?vue&type=script&lang=js"
import style0 from "./Annouce.vue?vue&type=style&index=0&id=6ec5ccc0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Annouce.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./Annouce.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports